"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Calculate = Calculate;
exports.PercentageChange = PercentageChange;
var _react = _interopRequireDefault(require("react"));
var _animations = require("../../shared/animations");
var _Badge = require("../Badge");
var _Loadable = require("../Loadable");
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Main component
// -------------------------------------------------------------------------------------------------

function PercentageChange({
  change,
  color,
  testId,
  value = 0,
  ...props
}) {
  if (typeof value === 'string') value = Number.parseFloat(value);

  // The the change prop wasn't set, figure out which indicator should be displayed based on the
  // `value` prop that was given.
  if (!change) {
    if (value > 0) change = 'up';else if (value < 0) change = 'down';else change = 'none';
  }
  const displayValue = Math.abs(Math.round(value));
  return /*#__PURE__*/_react.default.createElement(_Badge.Badge, {
    color: color,
    "data-testid": testId
  }, /*#__PURE__*/_react.default.createElement(_styled.StyledData, _extends({
    change: change,
    value: value
  }, props), displayValue, /*#__PURE__*/_react.default.createElement(_styled.StyledPercent, null, "%")));
}

//
// Sub-components
// -------------------------------------------------------------------------------------------------

PercentageChange.Calculate = Calculate;
/**
 * Utility component that helps caluclate and display the percentage change between two values.
 */
function Calculate({
  current,
  previous,
  ...rest
}) {
  if (typeof current === 'string') current = Number.parseFloat(current);
  if (typeof previous === 'string') previous = Number.parseFloat(previous);
  let percentChange = 0;
  if (current > 0 && previous > 0) percentChange = (current - previous) / previous * 100;
  return /*#__PURE__*/_react.default.createElement(PercentageChange, _extends({}, rest, {
    value: percentChange
  }));
}

//
// Utility components
// -------------------------------------------------------------------------------------------------

PercentageChange.Loadable = Loadable;
function Loadable({
  loading,
  placeholder,
  value,
  ...props
}) {
  const isLoading = (0, _Loadable.useLoadable)(loading);
  if (!isLoading) return /*#__PURE__*/_react.default.createElement(PercentageChange, _extends({
    value: value
  }, props));
  return /*#__PURE__*/_react.default.createElement(PercentageChange, _extends({
    color: "gray400",
    css: {
      animation: `${_animations.pulse} 1.5s linear infinite`,
      userSelect: 'none'
    },
    value: placeholder !== null && placeholder !== void 0 ? placeholder : value
  }, props));
}
Calculate.Loadable = CalculateLoadable;
function CalculateLoadable({
  current,
  loading,
  previous,
  placeholder,
  ...props
}) {
  const isLoading = (0, _Loadable.useLoadable)(loading);
  if (!isLoading && !!current && !!previous) {
    return /*#__PURE__*/_react.default.createElement(PercentageChange.Calculate, _extends({
      current: current,
      previous: previous
    }, props));
  }
  return /*#__PURE__*/_react.default.createElement(PercentageChange, _extends({
    color: "gray400",
    css: {
      animation: `${_animations.pulse} 1.5s linear infinite`,
      userSelect: 'none'
    },
    value: placeholder !== null && placeholder !== void 0 ? placeholder : 0.0
  }, props));
}